/**
 * HeavyUltronsSentries.js
 * The Heavy Ultrons Sentries Enemy class
 */

import { Game } from "pixi_core";
import { BubbleColor, EnemyAbilities, GameEvents } from "../Constants";
import { Enemy } from "./Enemy";
import { EnemyParticle } from "../game/particles/EnemyParticle";

export class HeavyUltronsSentries extends Enemy {
    /**
     * @public
     * @param {String} enemyName
     * @param {Object} enemyData
     * @param {Number} index
     * @param {Boolean} [summoned] - Summoned by an ability
     */
    constructor(enemyName, enemyData, index, summoned) {
        super(enemyName, enemyData, index, summoned);

        const probAddRandom = Game.utils.assertNumber(enemyData.ProbAddRandom, 1);
        const probPlasmaCannon = Game.utils.assertNumber(enemyData.ProbPlasmaCannon, 1);
        const probVibraniumShell = Game.utils.assertNumber(enemyData.ProbVibraniumShell, 1);

        // Single ability choice
        this._abilityChoices.addChoice(EnemyAbilities.eADD_RANDOM, probAddRandom);
        this._abilityChoices.addChoice(EnemyAbilities.eCHARGE_UP, probPlasmaCannon);
        this._abilityChoices.addChoice(EnemyAbilities.eVIBRANIUM_SHELL, probVibraniumShell);

        /** @private @type {Boolean} */
        this._isCharging = false;

        /** @private @type {Number} - Number of stone bubbles to cast with the AddRandom ability */
        this._nbStoneBubblesAdd = Game.utils.assertNumber(enemyData.NbStoneBubblesAdd, 1);
    }

    /**
     * @protected
     * @override
     * @param {EnemyAbilities} abilityName
     * @param {{x: Number, y: Number}} startPos
     */
    _useAbility(abilityName, startPos) {
        switch (abilityName) {
            case EnemyAbilities.eADD_RANDOM:
                let addBubbleDataColor = {
                    nbBubbles: this._nbBubblesAdd - this._nbStoneBubblesAdd,
                    color: BubbleColor.eRANDOM,
                    startPos: startPos,
                    dodgeFirst: false,
                    callback: null
                };
                Game.fire(GameEvents.eGAME_ABILITY_ADD_BUBBLE, addBubbleDataColor);

                let addBubbleDataStone = {
                    nbBubbles: this._nbStoneBubblesAdd,
                    color: BubbleColor.eSTONE,
                    startPos: startPos,
                    dodgeFirst: false,
                    callback: this._onAbilityCompleted.bind(this)
                };
                Game.fire(GameEvents.eGAME_ABILITY_ADD_BUBBLE, addBubbleDataStone);
                break;
            case EnemyAbilities.eCHARGE_UP:
                this._isCharging = true;
                Game.fire(GameEvents.eGAME_ABILITY_ENEMY_POWER_UP, this);
                this._chooseNextAction();
                break;
            case EnemyAbilities.eVIBRANIUM_SHELL:
                Game.fire(
                    GameEvents.eGAME_ABILITY_SHIELD_ENEMY,
                    this._shieldNbr,
                    this._shieldDuration,
                    100,
                    this._onAbilityCompleted.bind(this)
                );
                break;
            default:
                console.error("[HeavyUltronsSentries._useAbility] Invalid ability name : " + abilityName);
                this._chooseNextAction();
        }
    }

    /**
     * The attack particle has reached its target
     * @protected
     * @override
     * @param {EnemyParticle} particle
     */
    _onDamageParticleCompleted(particle) {
        if (this._isCharging) {
            const chargedDamage = this._attackDamage * (this._chargingDamageBonus / 100);
            Game.fire(GameEvents.eHEROES_HIT, chargedDamage, particle);
            Game.fire(GameEvents.eGAME_ABILITY_ENEMY_POWER_DOWN, this);
            this._isCharging = false;
        } else {
            Game.fire(GameEvents.eHEROES_HIT, this._attackDamage, particle);
        }

        this._chooseNextAction();
    }
}
